import { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Miradas from "@/pages/miradas/page";
import Masmed from "@/pages/masmed/page";
import Evidencias from "@/pages/evidencias/page";
import Datos from "@/pages/datos/page";
import Noticias from "@/pages/noticias/page";
import NoticiaDetalle from "@/pages/noticias-detail/page";
import Contacto from "@/pages/contacto/page";
import AdminLogin from "@/pages/admin-login/page";
import AdminPanel from "@/pages/admin/page";
import AdminManual from "@/pages/admin-manual/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/miradas",
    element: <Miradas />,
  },
  {
    path: "/masmed",
    element: <Masmed />,
  },
  {
    path: "/evidencias",
    element: <Evidencias />,
  },
  {
    path: "/datos",
    element: <Datos />,
  },
  {
    path: "/noticias",
    element: <Noticias />,
  },
  {
    path: "/noticias/:id",
    element: <NoticiaDetalle />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminPanel />,
  },
  {
    path: "/admin/manual",
    element: <AdminManual />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;